import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../context/UserContext";
import Swal from "sweetalert2";
import { StoreMenus } from "../../context/Menus";
import StaticMenu from "../common/menus/StaticMenus";
import MenuItem from "../common/menus/MenuItem";
import SideMenu from "../common/menus/SideMenu";

const StoreDashboardSideBarDrawer = () => {
  const [open, setOpen] = useState(window.innerWidth > 1114);
  const [activeMenu, setActiveMenu] = useState(
    window.location.href.split("https://vam30.com/fa/")[1]
  );
  const [subMenuOpen, setSubMenuOpen] = useState("");
  const navigate = useNavigate();

  const { userData, setUserData } = useUserContext();

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1114) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [window]);

  const toggleSidebar = () => {
    setOpen(!open);
  };

  const old_access_token = localStorage.getItem("old_access_token");

  const logOut = () => {
    Swal.fire({
      title: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#477CD1",
      cancelButtonColor: "white",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",
        icon: "no-border",
        title: "title-padding",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (!old_access_token) {
          localStorage.clear();
          document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          });
          setUserData(null);
          Swal.fire({
            title: "از حساب کاربری خود خارج شدید",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/");
          // window.location.href = "https://vam30.com"; // Redirect to external URL
        } else {
          old_access_token &&
            localStorage.setItem("access_token", old_access_token);

          localStorage.removeItem("old_access_token");
          navigate("/fa/admin-dashboard");
        }
      }
    });
  };

  const handleMenuItemClick = (menu: any) => {
    setActiveMenu(menu.src);
    if (
      !menu.subMenus &&
      menu.title !== "خروج از حساب" &&
      menu.title !== "بازگشت به پنل ادمین" &&
      !menu.disable
    )
      navigate(`/${menu.src}`);
    if (menu.title === "خروج از حساب" || menu.title === "بازگشت به پنل ادمین") {
      logOut();
    }
  };

  return (
    <div
      className={`select-none hidden md:block  ${
        open ? "  transition-width w-[230px]" : "w-[50px]"
      } lg:block sticky top-0 min-h-screen ease-in-out duration-300 z-50 bg-white`}
    >
      <div>
        <div className="h-[90px] relative flex items-end justify-between gap-[70px]">
          <a href="/" className="flex items-center">
            <img
              src="/images/logovam30.png"
              className={`${open ? "mb-5 cursor-pointer" : "hidden"}`}
              alt="Flowbite Logo"
              // onClick={() => navigate("/")}
            />
          </a>
          <img
            src="/icons/Keyboard-capslock.svg"
            className={`mb-5 bg-gray-100 rounded-lg absolute shadow-button_sm_hover left-0 p-2 ${
              open ? "-translate-x-1/2" : ""
            }`}
            alt="Flowbite Logo"
            onClick={toggleSidebar}
          />
        </div>
        <ul
          className={` ${
            !open && "flex flex-col justify-center items-center"
          } pt-6 `}
        >
          <MenuItem
            activeMenu={activeMenu}
            handleMenuItemClick={handleMenuItemClick}
            open={open}
            Menu={StoreMenus[0]}
            index={0}
            subMenuOpen={subMenuOpen}
            setSubMenuOpen={setSubMenuOpen}
          />
          <SideMenu
            Menu={StoreMenus}
            name={"store"}
            userData={userData}
            activeMenu={activeMenu}
            handleMenuItemClick={handleMenuItemClick}
            open={open}
            subMenuOpen={subMenuOpen}
            setSubMenuOpen={setSubMenuOpen}
          />
        </ul>
      </div>
      <StaticMenu
        activeMenu={activeMenu}
        handleMenuItemClick={handleMenuItemClick}
        open={open}
      />
    </div>
  );
};

export default StoreDashboardSideBarDrawer;
